const {loadScript, loadStyle} = require('./util/loadDependencies');
require('./util/foreach-polyfill');
// require('./util/ga-dev-fallback');

// Autocomplete
export default (jsBasePath) => jQuery(($) => {

	const triggerSearchSuggestions = () => {
		var xhr;
		var currentSuggestions;
		var baseURL = 'https://apps.carleton.edu/';
		var suggestionsSource = 'https://apps.carleton.edu/student/?module_api=gateway_search&module_identifier=mcla-studentGatewaySearch-mloc-banner_search-mpar-421ae00a0c39da6ba9d1c859a2cfe69a';
		[
			{
				selector: '.home-page-banner .input--suggest',
				menuClass: 'homepage__banner-search'
			},
			{
				selector: '.home-page-banner-mini .input--suggest',
				menuClass: 'homepage__banner-mini-search'
			},
		].forEach((args) => {
			new autoComplete({
				selector: args.selector,
				menuClass: args.menuClass,
				source: function (term, response) {
					try {
						xhr.abort();
					} catch (e) {
					}
					xhr = $.getJSON(suggestionsSource,
						{search_term: term},
						function (data) {
							response(data);
						}
					);
				},
				renderItem: function (item, search) {
					// escape special characters
					search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
					var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
					return '<div class="autocomplete-suggestion" data-val="' + item.label.replace(/"/g, '&quot;') + '" data-url="' + item.value.replace(/"/g, '&quot;') + '">' + item.label.replace(re, "<b>$1</b>") + '</div>';
				},
				onSelect: function (e, term, item) {
					if (item.getAttribute('data-url').length) {
						e.preventDefault();
						var url = item.getAttribute('data-url');
						url = url.replace(/^\//, baseURL);
						ga('send', 'event', 'Homepage', 'Search', term);
						window.location.href = url;

						return false;
					}
				}
			});
		});
	};

	loadScript(`${jsBasePath}./autoComplete/auto-complete.min.js`, triggerSearchSuggestions);
});
